import cache from "../utils/cache";

export default {
    changeAppLanguage(state, payload) {
        if (payload) state.app_language = payload;
        else {
            state.app_language = 'cn';
        }
    },
    changeLoading(state, payload) {
        state.loading = payload;
    },
    changePosition(state, payload) {
        state.position = payload;
        cache.setSession("position", state.position);
    },
    changeAlivePage(state, payload) {
        state.needKeepAlive = payload;
    },
    saveCurrent(state, payload) {
        state.current = payload;
    },
    addRouterHistory(state, payload) {
        state.routerHistory = payload;
        cache.setSession("router", state.routerHistory)
    },
    showRecommended(state, payload) {
        state.showRecommended = payload;
        cache.setSession("showRecommended", state.showRecommended)
    }
};


// WEBPACK FOOTER //
// ./src/store/mutations.js